module.exports = __webpack_public_path__ + "085a992d3565d26a9c4c00e22a5e371d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/white-mug.png
// module id = 851
// module chunks = 0